import { render } from "./EdoDocumentFlowCell.vue?vue&type=template&id=53c49018&scoped=true"
import script from "./EdoDocumentFlowCell.vue?vue&type=script&lang=js"
export * from "./EdoDocumentFlowCell.vue?vue&type=script&lang=js"

import "./EdoDocumentFlowCell.vue?vue&type=style&index=0&id=53c49018&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53c49018"]])

export default __exports__